import store from '../../../store';

/**
 * UI-only gate: require `feature_access['alert-triage']`.
 * Keeps casual bookmark/API probing off the screen; your APIs still enforce customer/session rules as usual.
 */
export async function aiTriageBeforeEnter(to, from, next) {
  const hasAiTriageAccess = (featureAccess) => Boolean(featureAccess && featureAccess['alert-triage']);

  try {
    const userData = await store.dispatch('ENSUREUSER');
    if (hasAiTriageAccess(userData && userData.feature_access)) {
      next();
      return;
    }
  } catch (e) {
    console.warn('[aiTriageBeforeEnter] Failed to load impersonated user.', e);
  }
  next({ path: '/home', replace: true });
}
